// 全局getters
const getters = {
	userInfo: state => state.user.userInfo,
	roles: state => state.user.roles,
	token: state => state.user.token,
	userId: state => state.user.userId,
	realName: state => state.user.realName,
	phone: state => state.user.phone,
	// 是否绑定企业
	isHasCompany: state => state.enterprise.isHasCompany,
	companyId: state => state.enterprise.companyId,
	// 是否是企业管理员
	isCompanyAdmin: state => state.enterprise.isCompanyAdmin,
	vipLevel: state => state.vip.vipLevel,
	// 是否是普通会员
	isNormalVip: state => state.vip.vipLevel === 'PTHY',
	// 是否是高级会员
	isVip: state => state.vip.vipLevel === 'VIP',
	// 是否是超级会员
	isSVip: state => state.vip.vipLevel === 'SVIP'
}

export default getters
